module.exports = __webpack_public_path__ + "img/justgiving.47bdb304.png";